import { I18N } from 'aurelia-i18n';
import { StringHelper } from '../../../../helpers/string-helper';
import { AccountPaymentItem } from '../../../../models/account-payment-item';
import { IValidationRule } from '../i-validation-rule';
import { RuleValidationResult } from '../rule-validation-result';

export class MeetsPortalAndPortfolioMaxAmountRule implements IValidationRule {
	constructor(private i18n: I18N, private items: AccountPaymentItem[], private portalMaximumPaymentAmount: number) { }

	validate(): RuleValidationResult {
		let result: RuleValidationResult = new RuleValidationResult();

		if (!this.items) {
			return result;
		}

		let max: number = 9999999999;
		let portfolioMaximumPaymentAmount: number = max;

		// in the case that no portal max is set, treat it like the default max, so it will not be factored in
		if (!this.portalMaximumPaymentAmount) {
			this.portalMaximumPaymentAmount = max;
		}

		// enforce portal and portfolio-level max payment on total payment. If multiple portfolios selected, it should use
		// the min of the max (most restrictive). If portal max is less than portfolio max, use portal max, and vice versa.
		let totalAmount: number = 0;

		this.items.forEach((i: AccountPaymentItem) => {
			if (i.isSelected) {
				if (i.paymentLimitSettings.maximumPaymentAmount != null &&
					i.paymentLimitSettings.maximumPaymentAmount !== 0 &&
					i.paymentLimitSettings.maximumPaymentAmount < portfolioMaximumPaymentAmount) {
					portfolioMaximumPaymentAmount = i.paymentLimitSettings.maximumPaymentAmount;
				}
				let parsedAmount: number = parseFloat(i.enteredAmount);
				if (!isNaN(parsedAmount)) {
					totalAmount += parsedAmount;
				}
			}
		});

		// use the minimum of portal and portfolio maximums
		max = (this.portalMaximumPaymentAmount < portfolioMaximumPaymentAmount) ? this.portalMaximumPaymentAmount : portfolioMaximumPaymentAmount;
		result.isValid = (totalAmount <= max);

		if (!result.isValid) {
			result.errorMessage = this.i18n.i18next.t('totalPaymentDoesNotMeetMaxLimits', {
				defaultValue: 'Total payment cannot exceed ' + StringHelper.formatCurrency(max) + '.',
				maxPayment: StringHelper.formatCurrency(max)
			});
		}

		return result;
	}
}
